<template>
<div>
    
    <router-link to='/' class="absolute -top-2 left-4 block md:hidden">
        <img src="@/assets/images/v2/Icon awesome-arrow-left.png" alt="" class="mx-auto mt-16">
    </router-link>

    <img src="@/assets/images/v2/Grupo 23.png" style="width: 180px" alt="" class="mx-auto mt-10">

    <div class="container">
        <div class="row">
            <div class="col-md-8 offset-md-2 text-center py-16">
                <div class="row flex items-center">

                    <div class="col-md-4">
                        <img src="@/assets/images/v2/OpcioA_600x600.gif" alt="" class="rounded-circle mx-auto">
                    </div>

                    <div class="col-md-8 md:pl-16 sm:text-center md:text-left">

                        <h3 class="uppercase text-girona text-4xl font-bold my-4">
                            Opció A
                        </h3>
                        <p class="font-bold">
                            Aquesta versió manté l'estructura actual de l'escut, simplifica els elements i suprimeix la corona, que no arriba a tenir una puntuació mínima de 5. El nom del club pren protagonisme i la paraula 'Girona' passa a la part superior mentre que a la inferior s'escriu per primera vegada el nom complet de l'entitat en català.
                        </p>
                        
                    </div>
                </div>
            </div>

            <div class="col-md-10 offset-md-1 text-center py-16">
                <div class="row flex items-center">

                    <div class="col-md-6">
                        <div class="relative mx-auto" style="width: 400px">
                            <img src="@/assets/images/v2/OpcioA_400x400.png" width="400" alt="" class="rounded-circle mx-auto" usemap="#map">
                            <div @click="nPlus = 1" class="w-7 h-7 cursor-pointer" style="position: absolute;top: 9%;right: 36%;z-index: 50;">
                                <img src="@/assets/images/v2/plus.png" alt="">
                            </div>
                            <div @click="nPlus = 4" class="w-7 h-7 cursor-pointer" style="position: absolute;top: 30%;right: 24.5%;z-index: 50;">
                                <img src="@/assets/images/v2/plus.png" alt="">
                            </div>
                            <div @click="nPlus = 0" class="w-7 h-7 cursor-pointer" style="position: absolute;top: 41%;right: 8%;z-index: 50;">
                                <img src="@/assets/images/v2/plus.png" alt="">
                            </div>
                            <div @click="nPlus = 3" class="w-7 h-7 cursor-pointer" style="position: absolute;top: 47%;right: 24.5%;z-index: 50;">
                                <img src="@/assets/images/v2/plus.png" alt="">
                            </div>
                            <div @click="nPlus = 2" class="w-7 h-7 cursor-pointer" style="position: absolute;top: 47%;right: 45%;z-index: 50;">
                                <img src="@/assets/images/v2/plus.png" alt="">
                            </div>
                        </div>
                    </div>

                    <div class="col-md-6 text-right md:text-left pl-8 md:pl-0">

                        <h3 class="uppercase text-girona text-4xl font-bold my-4 relative">
                            {{ nTitle[nPlus] }}
                            <span class="absolute h-2 bg-girona -bottom-3 w-1/3 right-0"></span>
                        </h3>
                        <p class="font-bold">
                            {{ nText[nPlus] }}
                        </p>
                        
                    </div>
                </div>
            </div>

        </div>
    </div>

    <div class="container">
        <div class="row">
            <div class="col-md-4 offset-md-4 text-center">
                <router-link to="/" class="btn btn-danger btn-block bg-girona mt-6 uppercase font-normal text-xl rounded-lg mb-12">
                    Tornar enrere
                </router-link>
            </div>
        </div>
    </div>


    <div class="partners bg-girona mt-12">
        <div class="container">
            <div class="row">
                <div class="col-md-12 my-3 d-flex justify-content-center align-items-center">
                    <div class="mt-3 mr-5 text-center">
                        <a href="https://gosbi.com/" target="_blank">
                            <img src="@/assets/img/partners/gosbi_white.png" class="img-fluid" style="width: 150px;" alt="">
                        </a>
                    </div>
                    
                    <div class="mt-3 mr-5 text-center">
                        <a href="https://eu.puma.com/es/es/home" target="_blank">
                            <img src="@/assets/img/partners/Logo_Puma.png" class="img-fluid" style="width: 100px;" alt="">
                        </a>
                    </div>
                    <div class="mt-3 mr-5 text-center">
                        <a href="https://es.costabrava.org/" target="_blank">
                            <img src="@/assets/img/partners/Logo_CostaBrava.png" class="img-fluid" style="width: 150px;" alt="">
                        </a>
                    </div>
                    <!-- <div class="mt-3 text-center">
                        <a href="https://www.factorenergia.com/es/" target="_blank">
                            <img src="@/assets/img/partners/Logo_Factorenergia.png" class="img-fluid" style="width: 150px;" alt="">
                        </a>
                    </div> -->
                </div>
                <div class="col-md-12 d-flex justify-content-center align-items-center">
                    <div class="mt-3 mr-5 text-center">
                        <a href="https://www.estrelladamm.com/es/" target="_blank">
                            <img src="@/assets/img/partners/Logo_EstrellaDamm.png" class="img-fluid" style="width: 120px;" alt="">
                        </a>
                    </div>
                    <div class="mt-3 mr-5 text-center">
                        <a href="https://www.caixabank.es/particular/home/particulares_es.html" target="_blank">
                            <img src="@/assets/img/partners/Logo_Caixabank.png" class="img-fluid" style="width: 150px;" alt="">
                        </a>
                    </div>
                    <div class="mt-3 text-center">
                        <a href="https://www.nissan.es/" target="_blank">
                            <img src="@/assets/img/partners/Logo_Nissan.png" class="img-fluid" style="width: 120px;" alt="">
                        </a>
                    </div>
                    <div class="mt-3 ml-5 text-center">
                        <a href="https://www.medplaya.es/" target="_blank">
                            <img src="@/assets/img/partners/Logo_MedPlaya.png" class="img-fluid" style="width: 150px;" alt="">
                        </a>
                    </div>
                </div>
                <div class="col-md-12 my-3 d-flex justify-content-center align-items-center">
                    <!-- <div class="mt-3 mr-5 text-center">
                        <a href="https://leoboeck.com/" target="_blank">
                            <img src="@/assets/img/partners/Logo_LeoBoek.png" class="img-fluid" style="width: 170px;" alt="">
                        </a>
                    </div> -->
                    <div class="mt-3 mr-5 text-center">
                        <a href="https://www.viajeselcorteingles.es/" target="_blank">
                            <img src="@/assets/img/partners/Logo_ECI.png" class="img-fluid" style="width: 150px;" alt="">
                        </a>
                    </div>
                    <!-- <div class="mt-3 mr-5 text-center">
                        <a href="https://www.besoccer.com/" target="_blank">
                            <img src="@/assets/img/partners/Logo_BeSoccer.png" class="img-fluid" style="width: 150px;" alt="">
                        </a>
                    </div> -->
                    <div class="mt-3 mr-5 text-center">
                        <a href="https://leoboeck.com" target="_blank">
                            <img src="@/assets/img/partners/LeoBoeck_Logo.png" class="img-fluid" style="width: 120px;" alt="">
                        </a>
                    </div>

                    <div class="mt-3 mr-5 text-center">
                        <a href="https://parlem.com/" target="_blank">
                            <img src="@/assets/img/partners/Logo_Parlem.png" class="img-fluid" style="width: 150px;" alt="">
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>

require('@/assets/css/app.css')
require('../bootstrap');

var mobile = require('is-mobile');

export default {
    data() {
        return {
            isMobile: mobile(),
            nPlus: 1,
            nTitle: [
                'CIRCUMFERÈNCIA',
                'NOM DEL CLUB',
                'AIGÜES',
                'SENYERA',
                'BLANC-I-VERMELL',
            ],
            nText: [
                'Es manté el color vermell actual però s’eixampla per encabir millor el nom del club',
                'La paraula “Girona” es situa a la part superior i permet escriure “Futbol Club” a la part inferior. Per primer cop apareix el nom complet a l’escut.',
                'Es redueix el nombre d’aigües i s’adopta la forma heràldica tradicional, la mateixa que apareix en multitud d’aplicacions i escuts arreu de la ciutat. L’escut on apareixen les aigües recupera la forma afrancesada de l’escut original.',
                'Es manté la bandera de Catalunya amb la mateixa forma i colors, però s’elimina el contorn de color negre.',
                'Es dibuixen menys quantitat de línies blanques i vermelles però amb més gruix per a que guanyin visibilitat, es modifica la inclinació i son paral·leles al rombe central, igual que en els escuts originals del Club.',
            ],
        }
    },
    components: {

    },
    mounted() {
        var instance = this
        window.Popper = require('popper.js').default;
        window.$ = window.jQuery = require('jquery');

        $(".js-area").on('click', function(e) {
            alert('oha')
        })
    },
    methods: {

    }
}
</script>
